// export const ALGOLIA_APP_ID = "OY40MHDAVN"
// export const ALGOLIA_API_KEY = "b439177690633d2b6e3c57c83fe430fd"

export const ALGOLIA_APP_ID = "MVW51GQLBT"
export const ALGOLIA_API_KEY = "6ab74c1a80be7279b1f998a63f84c133"